<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      header="Egyéb tételek"
      border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      class="text-center mt-2"
    >
      <div class="col-sm-6">
        <div class="row">
          <!-- // NEW -->
          <b-button
            size="sm"
            variant="primary"
            @click="$router.push({ name: 'CikkekNew' })"
            ><b-icon-plus-circle></b-icon-plus-circle>
            Új Egyéb tételek hozzáadása
          </b-button>
        </div>
      </div>

      <!-- // TABLE -->
      <div class="mt-3" >
        <table class="table labelsize table-striped text-right">
          <thead>
            <tr>
              <!-- <th>Id</th> -->
              <th class="text-left">Látható</th>
              <th class="text-left">Megnevezés</th>
              <th>Mennyiségi egység</th>
              <th>Nettó</th>
              <th>edit</th>
              <th>del</th>
            </tr>
          </thead>
          <tbody is="draggable" group="people" @end="onEnd" :list="list" tag="tbody">
            <tr  v-for="(element, index) in list" :key="element.id">
              <!-- <td>{{element.id}}</td> -->
              <td class="text-left">
                <b-form-checkbox v-model="element.hidden" switch size="sm" @change="radioOn(element)"></b-form-checkbox>
              </td>
              <td class="text-left">{{element.megnevezes}}</td>
              <td>{{element.mennyisegiegyseg}}</td>
              <td>{{element.netto}}</td>
              <td>
                <b-button
                  size="sm"
                  @click="
                    $router.push({
                      name: 'CikkekNew',
                      params: { id: element.id }
                    })
                  "
                  variant="outline-success"
                  class="mr-1"
                ><b-icon-pencil></b-icon-pencil>
                </b-button>
              </td>
              <td>
                <b-button
                  size="sm"
                  @click="showMsgBoxTwo(element.id)"
                  variant="outline-danger"
                  class="mr-1"
                  ><b-icon-trash></b-icon-trash>
                </b-button>              
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <!-- // TABLE -->
      <div class="mt-3" hidden>
        <b-table small striped hover :items="list" :fields="fields" :key="list.id">
          <!-- // EDIT -->
          <template v-slot:cell(edit)="row">
            <b-button
              size="sm"
              @click="
                $router.push({
                  name: 'CikkekNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-1"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import draggable from 'vuedraggable'

export default {
  components: {
          draggable,
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: [],
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          sortDirection: 'asc'
        },
        {
          key: 'megnevezes',
          label: 'Megnevezés',
          sortable: true,
          sortDirection: 'asc'
        },
        {
          key: 'mennyisegiegyseg',
          label: 'Mennyiségi egység',
          sortable: true,
          sortDirection: 'asc'
        },
        {
          key: 'netto',
          label: 'Nettó',
          sortable: true,
          sortDirection: 'asc'
        },
        { key: 'edit', sortable: true },
        { key: 'del', sortable: true }
      ]
    }
  },
  methods: {
    radioOn: function(el) {
      let id = el.id
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = id
        if(el.hidden== true){
          payload.hidden = 0
        } else {
          payload.hidden = 1
        }
        payload.megnevezes = el.megnevezes
        payload.mennyisegiegyseg = el.mennyisegiegyseg
        payload.netto = el.netto
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/save', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }      
    },
    onEnd: function(evt) { 
      for(let el in this.list) {
        this.list[el].order = el
      }
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.list = this.list
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/ordersave', { payload })
          .then(res => {
            //this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },     
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (reqData) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Biztos, hogy törölni akarod? ', {
          title: 'Megerősítés',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(reqData)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/getlist', { payload })
          .then(res => {
            this.list = res.data
            for(let el in this.list) {
              if (this.list[el].hidden == 0) {
              this.list[el].hidden = false
              } else {
              this.list[el].hidden = true
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cikkek.vue